import { getRoot } from 'mobx-easy';

import RootStore from 'bringg-web/stores/root-store';
import { hasFeatureFlag } from 'bringg-web/utils/feature-flags';
import { ALERTS_ADDITIONAL_TEXT_FF } from 'bringg-web/consts';
import { ALERT_DYNAMIC_COLUMN_IDS } from 'bringg-web/stores/alerts-view/consts';

type BaseColumn = { id: string };

// https://bringg.atlassian.net/browse/BRNGG-29287
const filterDefaultColumnsByFeatureFlags = <T extends BaseColumn>(columns: T[]): T[] => {
	const { currentUser } = getRoot<RootStore>().data.usersStore;
	const alertAdditionalTextEnabled = hasFeatureFlag(currentUser, ALERTS_ADDITIONAL_TEXT_FF);

	if (alertAdditionalTextEnabled) {
		return columns;
	}

	return columns.filter(c => c.id !== ALERT_DYNAMIC_COLUMN_IDS.AdditionalText);
};

export const alertsViewProvider = { filterDefaultColumnsByFeatureFlags };
